module.exports = "/dist/assets/images/logo-iiif.png";